import syncDialogs from './syncDialogs';

export default {
  data() {
    return {
      syncDialogVisible: false,
      syncDialog: {
        finished: false,
        linked: false,
        relation: [],
      },
      syncType: 'sync', // 同步弹窗类型，是同步还是消息推送
    };
  },
  components: {
    syncDialogs,
  },
  methods: {
    syncDataLoaded(data) {
      this.syncDialog = data;
    },
    /**
     * 显示同步到其他系统dialog
     */
    showSyncDialog() {
      this.syncType = 'sync';
      this.syncDialogVisible = true;
    },
    showSyncMsgDialog() {
      this.syncType = 'msg';
      this.syncDialogVisible = true;
    },
    hideSyncDialog() {
      this.syncDialogVisible = false;
    }
  },
};
